/**
 * Get community ID from various possible data sources
 * @param {Object} communityData - Community data object
 * @param {Object} pageData - Page data object (optional)
 * @returns {string|null} - The community ID or null if not found
 */
export const getCommunityId = (communityData, pageData = null) => {
  // Try multiple possible community ID sources
  const possibleSources = [
    communityData?.communityOfInterest,           // Salesforce community ID
    communityData?.tpc_priority_group_form?.crm_salesforce_id
  ];

  return possibleSources.find(id => id && id !== '') || null;
};

/**
 * Set up pre-chat fields when ready
 * @param {string | null} communityId - The SalesForce community id
 */
export const setupPrechatFields = (communityId) => {
  console.log('Setting up pre-chat fields');
  if (!communityId) {
    console.error('Community ID is required');
    return;
  }
  else if (!embeddedservice_bootstrap?.prechatAPI) {
    console.error('SF embedded service bootstrap not loaded')
    return;
  }

  // Get current page info
  const websiteUrl = document.documentURI;
  const referrerUrl = document.referrer;
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');

  // Set visible pre-chat fields
  embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
    _firstName: {
      value: '',
      isEditableByEndUser: true,
    },
    _lastName: {
      value: '',
      isEditableByEndUser: true,
    },
    _Phone: {
      value: '',
      isEditableByEndUser: true,
    },
    _Email: {
      value: '',
      isEditableByEndUser: true,
    },
  });

  // Set hidden pre-chat fields
  embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
    CommunityID: communityId,
    WebsiteURL1: websiteUrl.slice(0, 255),
    WebsiteURL2: websiteUrl.slice(255, 510),
    WebsiteURL3: websiteUrl.slice(510),
    ReferrerURL1: referrerUrl.slice(0, 255),
    ReferrerURL2: referrerUrl.slice(255, 510),
    ReferrerURL3: referrerUrl.slice(510),
    utm_source: decodeURIComponent(utmSource || ''),
    utm_medium: decodeURIComponent(utmMedium || ''),
    utm_campaign: decodeURIComponent(utmCampaign || ''),
    esdName: 'MIAW - TPH Website',
  });
};

/**
 * Update chat button visibility based on agent availability
 * Call this when you want to show/hide the chat button
 * @param {boolean} isVisible - Whether to show the chat button
 */
export const updateChatButtonVisibility = (isVisible) => {
  if (window.embeddedservice_bootstrap) {
    try {
      if (isVisible) {
        // Show chat button logic
        const chatButtons = document.querySelectorAll('.survey-chat-btn--online');
        chatButtons.forEach((btn) => {
          btn.style.setProperty('--btn-display', 'inline-flex');
        });

        const offlineButtons = document.querySelectorAll('.survey-chat-btn--offline');
        offlineButtons.forEach((btn) => {
          btn.style.setProperty('--btn-display', 'none');
        });
      } else {
        // Hide chat button logic
        const chatButtons = document.querySelectorAll('.survey-chat-btn--online');
        chatButtons.forEach((btn) => {
          btn.style.setProperty('--btn-display', 'none');
        });

        const offlineButtons = document.querySelectorAll('.survey-chat-btn--offline');
        offlineButtons.forEach((btn) => {
          btn.style.setProperty('--btn-display', 'inline-flex');
        });
      }
    } catch (error) {
      console.warn('Error updating chat button visibility:', error);
    }
  }
};